export default "__VITE_ASSET__CSrdGk0o__"